// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"aa56aebd","126":"6f13f6e3","131":"d1391389","251":"f36d73b7","396":"b8c67d0e","579":"2e6e773c","878":"c5e2dc06","932":"40ac325f"}[chunkId] + ".chunk.js";
};